import { datadogRum } from '@datadog/browser-rum';

import { whoami } from 'user/user.services';
import { IMPERSONATOR_TYPES } from 'constants/impersonatorTypes';

export const initDataDog = () => {
  if (
    window.location.host.includes('localhost') ||
    window.location.host.includes('staging')
  ) {
    return;
  }

  datadogRum.init({
    applicationId: '897a9333-206d-4b9c-a526-46fb69c5d23e',
    clientToken: 'pub118a3d49cf3792f122ad6d3cf87df61e',
    site: 'datadoghq.com',
    service: 'ownersportal',
    env: 'production',
    sessionSampleRate: 40,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'allow',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    storeContextsAcrossPages: true,
    usePartitionedCrossSiteSessionCookie: true,
    excludedActivityUrls: [
      /fullstory|pendo|zdassets|segment|split.io|saola.ai/,
      'https://app.guesty.com/api/track/web',
      'https://app.guesty.com/api/zendesk-integration/chat-jwt-token',
    ],
  });

  return true;
};

export const setDataDogUser = (user) => {
  const { impersonatorType, impersonator } = whoami();

  if (
    window.location.host.includes('localhost') ||
    window.location.host.includes('staging') ||
    !user?._id
  ) {
    return;
  }

  datadogRum.setUser({
    id: user._id,
    email: user.email,
    name: user.fullName,
    account_id: user.accountId,
    account_name: user.account?.name,
    locale: user.locale || 'en-US',
    impersonated: impersonatorType === IMPERSONATOR_TYPES.PM,
    ...(impersonatorType && { impersonator_type: impersonatorType }),
    ...(impersonator && { impersonator }),
  });
};
